<template lang="pug">
  fieldset.field(:disabled="fildDisabled")
    cp-label(
      :for="id"
      :label="label"
    )
    cp-select(
      v-if="type === 'select'"
      :disabled="disabled"
      :options="options"
      :value="value"
      @onChange="setValue"
    )
    cp-radio(
      v-else-if="type === 'radio'"
      v-for="(option, index) in options"
      :key="index"
      :id="`${name}-${index}`"
      :name="name"
      :option="option"
      :value="value"
      @onChange="setValue"
    )
    cp-input(
      v-else
      :class="{'input--error': validation.type === 'error'}"
      :disabled="disabled"
      :id="id"
      :mask="mask"
      :maxlength="maxlength"
      :name="name"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :onClick="onClick"
      @onChange="setValue"
    )

    //- Mensagens de validação
    .validation-msg(
      v-if="validation.msg"
      :class="{'validation-msg--error': validation.type === 'error'}"
    )
      span {{ validation.msg }}

    //- Slot para adicionar algum elemento
    slot
</template>
<script>
import CpLabel from '@/components/ui/Label.vue'
import CpInput from '@/components/ui/Input.vue'
import CpSelect from '@/components/ui/Select.vue'
import CpRadio from '@/components/ui/Radio.vue'
export default {
  name: 'Field',
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fildDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => [
        {
          value: 1,
          label: 'Selecione'
        }
      ]
    },
    mask: {
      default: ''
    },
    validation: {
      type: Object,
      default: () => {
        return {
          type: 'default',
          msg: null,
          valid: null
        }
      }
    },
    maxlength: {
      type: [String, Number],
      default: null
    },
    onClick: {
      type: Function
    }
  },
  components: {
    CpLabel,
    CpInput,
    CpSelect,
    CpRadio
  },
  methods: {
    setValue (value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/style/ui/variables";
.field {
  position: relative;
  width: 100%;
  border: none;
  &:not(:last-child) {
    margin-right: 7px;
    @media screen and (min-width: 768px) {
      margin-right: 16px;
    }
  }
  &:disabled {
    opacity: 0.4;
  }
  .label {
    display: block;
    font-family: $oscine-font-family;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;

    @media screen and (min-width: 768px) {
      font-size: 16px;
    }
  }
  .validation-msg {
    color: #444444;
    font-family: $rubik-font-family;
    font-size: 12px;
    line-height: normal;
    margin-top: 2px;
    max-width: 100%;
    &--error {
      color: #ff3b30;
      margin-top: 5px;
    }
  }
}
</style>
